module.exports = __webpack_public_path__ + "img/no-data.bf93be2b.svg";